// extracted by mini-css-extract-plugin
export default {"secret":"OAuthClientDetail_secret__cpMND","button":"OAuthClientDetail_button__zY3i3"};